import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phoneFormat',
  standalone: true
})
export class PhoneFormatPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) return '';
    
    const numbers = value.toString().replace(/\D/g, '').substring(0, 10);
    let formatted = '';
    
    if (numbers.length > 0) {
      formatted = '(' + numbers.substring(0, 3);
      if (numbers.length > 3) {
        formatted += ') ' + numbers.substring(3, 6);
        if (numbers.length > 6) {
          formatted += '-' + numbers.substring(6);
        }
      }
    }
    return formatted;
  }
} 